module.exports = __webpack_public_path__ + "img/jk_icon_fenxiangweibo.8dc41658.png";